import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'warehouseReleaseDocuments/'

export const warehouseReleaseDocumentsService = {
  getAllPaginate,
  getById,
  getByIdForPrint,
  add,
  edit,
  delete: _delete
}

function getAllPaginate(dto) {
  const url = base_url + model + 'getAllPaginate'
  console.log(url)
  console.log(dto)
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getById(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getByIdForPrint(id) {
  const url = base_url + model + 'getByIdForPrint/' + id
  console.log(url)

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(dto) {
  const url = base_url + model
  console.log(url)
  console.log(dto)

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function edit(id, dto) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, dto, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}
